/**
 * Общие типы свечей. Раньше CHSort и CandleInterval были продублированы
 * в binance/api.ts и polymarket/api.ts, причём копии разошлись: в polymarket
 * не было SEC_10, хотя Market-сцена импортировала именно это значение
 * (из binance) и передавала его в оба запроса.
 */

export enum CHSort {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum CandleInterval {
  SEC_1 = 1_000,
  SEC_5 = 5_000,
  SEC_10 = 10_000,
  SEC_15 = 15_000,
  SEC_30 = 30_000,

  MIN_1 = 60_000,
}

export type BaseCandleDto = {
  ts: number

  open: number
  high: number
  low: number
  close: number

  volume: number

  buyVolume: number
  sellVolume: number

  trades: number
}

export interface BaseCandleFilter {
  startTime?: number
  endTime?: number

  intervalMs: CandleInterval

  limit?: number
  offset?: number
  sort: CHSort
}

type QueryValue = string | number | boolean | undefined | null

/** Один сборщик query-строки вместо четырёх копий цепочек `if (dto.x) params.append(...)`. */
export const buildQueryString = (params: Record<string, QueryValue>): string => {
  const search = new URLSearchParams()

  for (const [ key, value ] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue
    search.append(key, String(value))
  }

  return search.toString()
}
